<template>
    <Navbar></Navbar>
    <br/>
    <div v-if="!showMsgSemVistorias" class="container-fluid" style="">
        <div class="row">
            <div class="col-lg-8">
                <h2 style="margin-left: 10px">Últimas 10 vistorias realizadas</h2>
                <br/>
                <Table :vistorias="ultimasVistorias" :email="email"></Table>
                <p style="margin-left: 10px" v-if="ultimasVistorias != null"><strong>{{numVistorias}}</strong> vistoria(s) encontrada(s)</p>    

            </div>
            <div class="col-lg-4">
                
                <h2 style="margin-left: 10px">Localizador de placa</h2>
                <br/> 
                <div class="row" style="margin-left: 1px">
                    <div class="col-md-8" style="">
                        <label>Placa do veículo</label>
                        <input type="text" class="form-control" v-model="placa" placeholder="Digite a placa do veículo" maxlength="8" @keyup.enter="buscaPorPlaca">
                    </div>

                    <div class="col-md-4">
                        <br/>
                        <div v-if="placa != ''">
                            <button  @click="buscaPorPlaca" class="btn btn-primary"> Localizar</button>
                        </div>
                    </div>
                </div>
            </div>
              
            

        </div>
        <div style="margin-top: 80px" v-if="ultimasVistorias != null" class="container">
            <p style="text-align: center" class="alert alert-warning"><b>Atenção:</b> Área destinada ao vistoriador. Este aplicativo mostra apenas vistorias do vistoriador logado.</p>
        </div>   
    </div>

    <div v-else class="alert alert-primary" style="text-align: center;">
        <strong>Nenhuma vistoria realizada até o momento.</strong>
    </div>
        
</template>


<script>

import Table from '../components/Table.vue'
import APIv3 from '../services/apiv3-endpoints'
import Navbar from '../components/Navbar.vue'
const token = localStorage.getItem('token')
const vistoriador = localStorage.getItem('idUsuario')

export default {
    mounted: function (){
        this.mostrarUltimas10()
        this.getDadosPessoais()
        this.precisaAtualizarPerfil()
    },
    components:{
        Table,
        Navbar
    },

    data(){
        return{
            ultimasVistorias: null,
            placa: "",
            email: localStorage.getItem('email'),
            numVistorias: 0,
            showMsgSemVistorias: false,
        }
    },


    methods: {
        mostrarUltimas10(){
            APIv3.getUltimas10Vistorias(token, vistoriador)
                .then(response =>{
                    this.ultimasVistorias = response.data
                    this.numVistorias = this.ultimasVistorias.length
                    if(this.numVistorias == 0){
                        this.showMsgSemVistorias = true
                    }
                })
                .catch(err => {    
                    console.log(err)
                })
        },

        buscaPorPlaca(){
            this.$router.replace({ path: 'Listagem-placa', query: { placa: this.placa }})
        },

        showAlert() {
            this.$swal("Atenção!",'Área destinada ao vistoriador, apenas vistorias realizadas pelo vistoriador logado aparecerão.')
        },
        showAlertDadosPessoais() {
            console.log(localStorage.getItem('mostrarMensagem'))
            if  (localStorage.getItem('mostrarMensagem') === 'true') {
                this.$swal.fire ({
                    title: 'Atenção',
                    icon: 'warning',
                    text: 'Você precisa atualizar seu perfil!',
                    confirmButtonText: 'Atualizar',
                    showCancelButton: 'true',
                    cancelButtonText: 'Fechar',
                }) 
                .then (result => {
                    if (result.isConfirmed) {
                        this.$router.push('/Dados-Pessoais')                    
                    }
                })
                localStorage.mostrarMensagem = false
            }
        },
        getDadosPessoais() {
            APIv3.getDadosPessoaisJSON(vistoriador)
                .then(response => {
                    const dadosPessoais = response.data
                    localStorage.celular = dadosPessoais.celular
                    localStorage.data_nascimento = dadosPessoais.data_nascimento
                    localStorage.ultima_atualizacao = dadosPessoais.ultima_atualizacao
                    localStorage.sexo = dadosPessoais.sexo
                })
                .catch(err => {
                    console.log(err)
                })
        },
        precisaAtualizarPerfil () {
            APIv3.getPrecisaAtualizarPerfil(vistoriador)
                .then(response => {
                    const precisaAtualizarPerfil = response.data
                    if (precisaAtualizarPerfil.perfilPrecisaSerAtualizado === true) {
                        this.showAlertDadosPessoais()
                    }
                })
        },   
    }
}

</script>


<style>

</style>